var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 7,
    fill: "#2C4657"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 11.7735C18.9602 11.7668 18.9135 11.7668 18.8735 11.7735C17.9535 11.7402 17.2202 10.9868 17.2202 10.0535C17.2202 9.10016 17.9869 8.3335 18.9402 8.3335C19.8935 8.3335 20.6602 9.10683 20.6602 10.0535C20.6535 10.9868 19.9202 11.7402 19.0002 11.7735Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3135 16.6269C19.2268 16.7803 20.2335 16.6203 20.9401 16.1469C21.8801 15.5203 21.8801 14.4936 20.9401 13.8669C20.2268 13.3936 19.2068 13.2336 18.2935 13.3936",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9798 11.7735C11.0198 11.7668 11.0665 11.7668 11.1065 11.7735C12.0265 11.7402 12.7598 10.9868 12.7598 10.0535C12.7598 9.10016 11.9932 8.3335 11.0398 8.3335C10.0865 8.3335 9.31982 9.10683 9.31982 10.0535C9.32649 10.9868 10.0598 11.7402 10.9798 11.7735Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 16.6269C10.7533 16.7803 9.74663 16.6203 9.03996 16.1469C8.09996 15.5203 8.09996 14.4936 9.03996 13.8669C9.75329 13.3936 10.7733 13.2336 11.6866 13.3936",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 16.7535C14.9602 16.7468 14.9135 16.7468 14.8735 16.7535C13.9535 16.7201 13.2202 15.9668 13.2202 15.0335C13.2202 14.0801 13.9869 13.3135 14.9402 13.3135C15.8935 13.3135 16.6602 14.0868 16.6602 15.0335C16.6535 15.9668 15.9202 16.7268 15.0002 16.7535Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 18.8532C12.12 19.4799 12.12 20.5066 13.06 21.1332C14.1266 21.8466 15.8733 21.8466 16.94 21.1332C17.88 20.5066 17.88 19.4799 16.94 18.8532C15.88 18.1466 14.1266 18.1466 13.06 18.8532Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.ce1a526a83eea8cd4e5791f83e30398d.svg";
export { ForwardRef as ReactComponent };